// Capture beforeinstallprompt as early as possible (before React mounts),
// so the install CTA does not miss the event.
let deferredPrompt = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new CustomEvent("k9installready"));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    window.dispatchEvent(new CustomEvent("k9installed"));
  });
}

export const getDeferredPrompt = () => deferredPrompt;
export const clearDeferredPrompt = () => { deferredPrompt = null; };
